<template>
  <div>
    <v-dialog
      v-model="translationsDialog"
      hide-overlay
      persistent
      max-width="1000"
    >
      <v-card class="elevation-0">
        <v-layout justify-center>
          <v-flex xs11>
            <v-form
              v-model="valid"
              lazy-validation
              ref="translationsForm"
            >
              <v-card class="elevation-0 transparent">
                <v-layout column pb-4>
                  <v-flex ma-1>
                    <v-layout>
                      <v-icon
                        color="primary"
                        style="font-size: 40px;"
                      >
                        border_color
                      </v-icon>
                      <h1
                        :style="`color: ${$vuetify.theme.primary}`"
                        class="mt-3 ml-4"
                      >Translations
                      </h1>
                    </v-layout>
                  </v-flex>
                  <v-flex ma-1>
                    <v-layout>
                      <v-flex ma-1>
                        <v-layout row ma-1>
                          <v-icon
                            color="secondary"
                            style="font-size: 40px;"
                          >
                            chat_bubble_outline
                          </v-icon>
                          <h2
                            :style="`color: ${$vuetify.theme.secondary}`"
                            class="ml-4"
                          >
                            {{languageSpec}}
                          </h2>
                        </v-layout>
                        <v-card ma-1 style="border-radius: 1em;">
                          <v-list
                            style="max-height: 200px"
                            class="scroll-y"
                          >
                            <template v-for="(item, index) in languages">
                              <v-list-tile
                                :key="item.LocalName"
                                ripple
                                @click="toggle(index)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    {{ item.LocalName }}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon
                                    v-if="selected !== index"
                                    color="grey lighten-1"
                                  >
                                    keyboard_arrow_right
                                  </v-icon>
                                  <v-icon
                                    v-else
                                    color="grey darken-2"
                                  >
                                    arrow_forward_ios
                                  </v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-divider
                                v-if="index + 1 < languages.length"
                                :key="index"
                              ></v-divider>
                            </template>
                          </v-list>
                        </v-card>
                      </v-flex>
                      <v-flex ma-1>
                        <v-layout column ma-1>
                          <v-flex>
                          <h4>{{$translate('LANGUAGE')}}</h4>
                          <v-text-field
                            v-model="language.LocalName"
                            rows="1"
                            auto-grow
                            :label="language.LocalName"
                            required
                            solo
                            readonly
                          />
                          </v-flex>
                          <v-card class="elevation-0 transparent scrollablePage">
                            <div v-for="(column, index) in reversedColumns" :key="index">
                              <v-flex>
                                <h4 class="mt-2">{{ column.Field }}</h4>
                                <v-textarea
                                  v-model="translations[language.LanguageId][column.Field]"
                                  auto-grow
                                  box
                                  outline
                                  solo
                                  color="primary"
                                  rows="1"
                                ></v-textarea>
                              </v-flex>
                            </div>
                          </v-card>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex ma-1>
                    <v-layout>
                      <v-spacer/>
                      <v-tooltip bottom>
                        <v-btn
                          round
                          slot="activator"
                          color="secondary"
                          class="v-btn-5 dialogButton text-capitalize"
                          @click="closeTranslations"
                        >{{$translate('CLOSE')}}</v-btn>
                        <span>{{$translate('CLOSE')}}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn
                          round
                          slot="activator"
                          color="secondary"
                          class="v-btn-5 dialogButton text-capitalize"
                          @click="saveTranslations"
                        >{{$translate('SAVE')}}</v-btn>
                        <span>{{$translate('SAVE')}}</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as dssRequest from '../api/dssRequest';
import BaseObject from '../objects/BaseObject';

export default {
  name: 'Generic_Translations',
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    translations: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
  },
  data() {
    return {
      // Static data in this form.
      languageSpec: 'Language specifics',
      valid: true,

      // Data read from the database.
      languages: [],

      // Data read from this form.
      language: '',

      // Variables.
      receivedColumns: [],
      receivedTranslations: {},
      translationsDialog: false,
      selected: -1,
    };
  },
  computed: {
    reversedColumns() {
      return this.columns.slice().reverse();
    },
  },
  mounted() {
    console.log("Lorenzo this.columns", this.columns);
    this.translationsDialog = true;
    this.getAllLanguageTags();
  },
  methods: {
    getAllLanguageTags() {
      // This used to be the generic call getAllLanguageTags
      const payload = {
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getAllLanguageTags was successful',
            response,
          );
          if (!response.hasOwnProperty('data')) {
            console.error(
              `[${
                this.$options.name
              }] Response on getAllLanguageTags() doesn't have data.`,
            );
            return;
          }

          if (!response.data.hasOwnProperty('Languages')) {
            console.error(
              `[${
                this.$options.name
              }] Response on getAllLanguageTags() doesn't have Languages.`,
            );
            return;
          }

          this.languages = [];
          this.languages = [...response.data.Languages];

          this.languages.forEach(data => {
            if(data.Icon === '' || data.Icon === 'NULL') {
              if (data.LanguageId == "13") {
                data.Icon = require("@/assets/countryIcons/united-kingdom.png");
              } else if (data.LanguageId == "14") {
                data.Icon = require("@/assets/countryIcons/netherlands.png");
              } else if (data.LanguageId == "15") {
                data.Icon = require("@/assets/countryIcons/italy.png");
              } else if (data.LanguageId == "16") {
                data.Icon = require("@/assets/countryIcons/france.png");
              } else if (data.LanguageId == "17") {
                data.Icon = require("@/assets/countryIcons/germany.png");
              }
            }
          });

          if (this.languages.length > 0) this.toggle(0);
          this.addMissingLanguageTranslations();
        },
        (error) => {
          console.log(
            'The generic call getAllLanguageTags was not successful',
            error,
          );
        },
        'getAllLanguageTags',
        this.$store.getters.getCurrentAccountId,
        payload,
      );
    },
    addMissingLanguageTranslations() {
      this.languages.forEach((lang) => {
        if (!this.translations.hasOwnProperty(lang.LanguageId)) {
          this.translations[lang.LanguageId] = {};
          this.columns.forEach((column) => {
            this.translations[lang.LanguageId][column.Field] = '';
          });
        }
      });
    },
    toggle(ToggleIndex) {
      if (ToggleIndex !== this.selected) {
        this.selected = ToggleIndex;
        this.language = this.languages[ToggleIndex];
        this.visualizeEventTranslations(ToggleIndex);
      }
    },
    visualizeEventTranslations(index) {
      let LanguageObject = {};

      if (index !== undefined) {
        LanguageObject = this.languages[index];
      } else {
        // A for-if loop can be used with break. A forEach loop can not be used with break.
        for (const [i, e] of this.languages.entries()) {
          console.log('I E ', i, e);
          // if (this.EventTranslations[e.LanguageTagId] !== undefined) {
          LanguageObject = e;
          index = i;
          break;
          // }
        }
      }

      if (index === undefined) {
        console.error(
          `[${
            this.$options.name
          }] Response on getEventTranslations() doesn't have data.`,
        );
        if (this.languages.length > 0) {
          this.selected = 0;
          this.language = this.languages[0];
        }
        return;
      }
      this.selected = index;
      this.language = LanguageObject;
    },
    closeTranslations() {
      this.$emit('closeTranslations', {});
    },
      saveTranslations() {
      console.log("Lorenzo this.translations", this.translations);
      this.$emit('saveTranslations', this.translations);
    },
  },
};
</script>

<style scoped lang="scss">
  .scrollablePage {
    height: calc(40vh);
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
